export default __webpack_public_path__ + "1-tell-us-what-you-need.6f1a457e.png";